import { useState } from "react";

export default function UploadImage({ onUploaded }: { onUploaded?: (url: string) => void }) {
  const [preview, setPreview] = useState("");
  async function upload(file: File) {
    setPreview(URL.createObjectURL(file));
    const form = new FormData();
    form.append("file", file);
    const res = await fetch("/api/upload", { method: "POST", body: form, credentials: "include" });
    const json = await res.json() as { ok: boolean; data?: { url: string } };
    if (json.ok && json.data) onUploaded?.(json.data.url);
  }
  return (
    <label className="block cursor-pointer rounded-lg border border-dashed border-slate-300 bg-slate-50 p-4 text-center">
      {preview ? <img src={preview} className="mx-auto max-h-40 rounded-md" /> : <span className="text-sm text-slate-500">Upload jpg, png, webp, gif or pdf up to 5MB</span>}
      <input hidden type="file" accept=".jpg,.jpeg,.png,.webp,.gif,.pdf" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])} />
    </label>
  );
}
